import React, { useState } from 'react';
import './SubjectModules.css'; // Make sure you have this file or adjust as needed
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const ChemistryModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Thermodynamics', path: '/ch-m1-s1' },
      { name: 'Concept of Activation Energy', path: '/ch-m1-s2' },
      { name: 'Catalysts and Enzymes', path: '/ch-m1-s3' }
    ],
    'Module 2': [
      { name: 'Inorganic complexes and organometallics', path: '/ch-m2-s1' },
      { name: 'Metals in Biology (Haemoglobin and chlorophyll)', path: '/ch-m2-s2' }
    ],
    'Module 3': [
      { name: 'Organic intermediates and aromaticity', path: '/ch-m3-s1' },
      { name: 'Drugs and dyes', path: '/ch-m3-s2' }
    ],
    'Module 4': [
      { name: 'Batteries', path: '/ch-m4-s1' },
      { name: 'Fuel cells and Solar cells', path: '/ch-m4-s2' }
    ],
    'Module 5': [
      { name: 'Polymers', path: '/ch-m5-s1' },
      { name: 'Nano Materials', path: '/ch-m5-s2' }
    ],
    'Module 6': [
      { name: 'Spectroscopic, diffraction, and microscopic technique', path: '/ch-m6-s1' }
    ],
    'Module 7': [
      { name: 'Water purification', path: '/ch-m7-s1' },
      { name: 'Fuels and Combustion', path: '/ch-m7-s2' },
      { name: 'Corrosion Control', path: '/ch-m7-s3' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Chemistry</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-ChemistryModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>No topics available.</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChemistryModules;
